function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  const html = document.documentElement;
  return rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || html.clientHeight) &&
    rect.right <= (window.innerWidth || html.clientWidth);
}

export default class Popover {
  constructor(trigger, { position = 'top', className = 'demogPopover', template = '', overrideColor = null }) {
    this.trigger = trigger;
    this.position = position;
    this.className = className;
    this.orderedPositions = ['top', 'right', 'bottom', 'left'];

    const popoverTemplate =  document.querySelector(`[data-popover="${template.length > 0 ? template : trigger?.dataset?.popoverTarget}"]`);
    this.popover = document.createElement('div');
    this.popover.dataset.dg = "1";
    this.popover.innerHTML = popoverTemplate.innerHTML;

    Object.assign(this.popover.style, {
      position: 'fixed',
      'z-index': '99999999999999'
    });

    if (overrideColor?.length > 0) {
      this.popover.style.backgroundColor = overrideColor;
      this.popover.style.borderColor = overrideColor;
      this.popover.style.boxShadow = `0 1px 4px ${overrideColor}`;
      const styleSheet = document.styleSheets[0];
      styleSheet.insertRule(`.demogAnnotate--top::before { border-top-color: ${overrideColor} !important }`, styleSheet.cssRules.length);
      styleSheet.insertRule(`.demogAnnotate--top::after { border-top-color: ${overrideColor} !important }`, styleSheet.cssRules.length);
      styleSheet.insertRule(`.demogAnnotate--bottom::after { border-bottom-color: ${overrideColor} !important }`, styleSheet.cssRules.length);
      styleSheet.insertRule(`.demogAnnotate--bottom::before { border-bottom-color: ${overrideColor} !important }`, styleSheet.cssRules.length);
    }

    this.popover.classList.add(className);

    this.handleWindowEvent = () => {
      if (this.isVisible) {
        this.show();
      }
    };

    this.handleDocumentEvent = (evt) => {
      if (this.isVisible && evt.target !== this.trigger && evt.target !== this.popover) {
        this.popover.remove();
      }
    };
  }

  get isVisible() {
    return document.body.contains(this.popover);
  }

  show() {
    document.addEventListener('click', this.handleDocumentEvent);
    window.addEventListener('scroll', this.handleWindowEvent);
    window.addEventListener('resize', this.handleWindowEvent);
    document.body.addEventListener('scroll', this.handleWindowEvent);

    document.body.appendChild(this.popover);

    const { top: triggerTop, left: triggerLeft } = this.trigger.getBoundingClientRect();
    const { offsetHeight: triggerHeight, offsetWidth: triggerWidth } = this.trigger;
    const { offsetHeight: popoverHeight, offsetWidth: popoverWidth } = this.popover;

    const positions = {
      top: {
        name: 'top',
        top: triggerTop - popoverHeight,
        left: triggerLeft - ((popoverWidth - triggerWidth) / 2)
      },
      right: {
        name: 'right',
        top: triggerTop - ((popoverHeight - triggerHeight) / 2),
        left: triggerLeft + triggerWidth
      },
      bottom: {
        name: 'bottom',
        top: triggerTop + triggerHeight,
        left: triggerLeft - ((popoverWidth - triggerWidth) / 2)
      },
      left: {
        name: 'left',
        top: triggerTop - ((popoverHeight - triggerHeight) / 2),
        left: triggerLeft - popoverWidth
      }
    };

    // Simply use the specified position without checking viewport
    const position = positions[this.position];
    this.popover.style.top = `${position.top}px`;
    this.popover.style.left = `${position.left}px`;

    this.orderedPositions.forEach(pos => {
      this.popover.classList.remove(`${this.className}--${pos}`);
    });

    this.popover.classList.add(`${this.className}--${this.position}`);
  }

  hide() {
    this.popover.remove();

    document.removeEventListener('click', this.handleDocumentEvent);
    window.removeEventListener('scroll', this.handleWindowEvent);
    window.removeEventListener('resize', this.handleWindowEvent);
    document.body.removeEventListener('scroll', this.handleWindowEvent);
  }

  toggle() {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }
} 